/**
 * Outveil: swaps an image-with-text block's photo to match the color the
 * shopper just picked on the product page, using the {color: {src, alt}}
 * map from custom.image_1_by_color (embedded per block as an HTML attribute,
 * not an inline <script> tag - some installed app strips those and leaves
 * their text content visible on the page). Only runs on blocks that opted
 * in via sync_image_with_color - see sections/image-with-text.liquid.
 */
(function () {
  function wireUp(wrapper) {
    var img = wrapper.querySelector('img');
    var rawJson = wrapper.getAttribute('data-color-sync-json');
    if (!img || !rawJson) return;

    var map;
    try {
      map = JSON.parse(rawJson);
    } catch (e) {
      return;
    }

    var optionPosition = parseInt(wrapper.getAttribute('data-color-option-position'), 10);
    if (!optionPosition) return;

    function applyVariant(variant) {
      if (!variant) return;
      var colorValue = variant['option' + optionPosition];
      var entry = colorValue && map[colorValue];
      if (!entry) return;
      img.src = entry.src;
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      if (entry.alt) img.alt = entry.alt;
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        applyVariant(event.data && event.data.variant);
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-color-sync-map]').forEach(wireUp);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
